import React from 'react';
import { useEffect } from 'react';
import {  Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import useConfirm from '../../hooks/useConfirm';
import Button from '../Button';
import { Close } from '@mui/icons-material';
import { Dialog, DialogTitle, Box, IconButton, DialogContent, DialogActions, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const ConfirmModal = ({ value = '' }) => {
  const { onConfirm, onCancel } = useConfirm();
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    // console.log('value', value)
    if (value) setOpen(true);
  }, [value]);

  const handleConfirm = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
    onConfirm();
  };

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    setOpen(false);
    onCancel();
  };

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth TransitionComponent={Transition}>
    <DialogTitle>Confirm</DialogTitle>
    <Box position="absolute" top={0} right={0}>
      <IconButton onClick={handleClose}>
        <Close />
      </IconButton>
    </Box>
    <DialogContent>{value}</DialogContent>
    <DialogActions>
    
      <Button variant="contained" onClick={handleConfirm}>
        Ok
      </Button>
      <Button variant="contained" onClick={handleClose}>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
  );
};

export default ConfirmModal;
